import { SettingsApiBase, SettingsBase } from 'src/api';
import { Injectable, inject } from '@angular/core';
import { ToolingTask } from './tooling-tasks.model';
import { ColumnBaseConfig, columnBaseToSettings } from '../config-utils';
import { HttpClient } from '@angular/common/http';
import { apiRoots } from 'src/config';
import { US_BASE_URL } from 'src/api/tokens';

const toolingTasksSettingsKey = 'maintenanceassistant_settings:toolingTasksSettings';

export const toolingTaskColumnsBaseConfig: ColumnBaseConfig<ToolingTask> = [
  { key: 'toolingName', name: 'Tooling', width: '150px' },
  { key: 'manufacturer', name: 'Manufacturer', width: '150px' },
  { key: 'inventoryNo', name: 'Inventory Number', width: '150px' },
  { key: 'serial', name: 'Serial Number', width: '150px' },
  { key: 'schenckMatNo', name: 'Schenck Material Number', width: '150px' },
  { key: 'verificationLevel', name: 'Verification Level', width: '150px' },
  { key: 'customerId', name: 'Task ID Customer', width: '150px', invisible: true },
  { key: 'schenckId', name: 'Task ID Schenck', width: '150px' },
  { key: 'title', name: 'Title', width: '150px' },
  { key: 'priority', name: 'Priority', width: '150px' },
  { key: 'responsibleCompany', name: 'Responsible Company', width: '150px' },
  { key: 'responsible', name: 'Task Responsible', width: '150px', invisible: true },
  { key: 'executive', name: 'Task Executive', width: '150px' },
  { key: 'dueDate', name: 'Due Date', width: '150px' },
  { key: 'status', name: 'Status', width: '150px' },
  { key: 'description', name: 'Description', width: '150px', invisible: true },
  { key: 'type', name: 'Task Type', width: '150px', invisible: true },
  { key: 'expectedDurationMinutes', name: 'Expected Duration', width: '150px', invisible: true },
  { key: 'scheduling', name: 'Interval', width: '150px', invisible: true },
  { key: 'machines', name: 'Machine(s)', width: '200px' },
  { key: 'toolingForRotor', name: 'TOOLING_For Rotor(s)', width: '150px' },
  { key: 'mainContact', name: 'Main Contact', width: '150px' },
  { key: 'storageLocation', name: 'Storage Location', width: '150px' },
  { key: 'workplace', name: 'Workplace', width: '150px', invisible: true },
];

export interface ToolingTaskSettings extends SettingsBase<keyof ToolingTask> {}

export const toolingTaskSettingsDefaults: ToolingTaskSettings = columnBaseToSettings(
  toolingTaskColumnsBaseConfig
);

@Injectable()
export class ToolingTaskSettingsApi extends SettingsApiBase<
  keyof ToolingTask,
  ToolingTaskSettings
> {
  constructor() {
    const http = inject(HttpClient);
    const usBaseUrl = inject(US_BASE_URL);

    const baseUrl = usBaseUrl + '/v1/currentuser/MaintenanceAssistant';
    const updateUrl = baseUrl + apiRoots.toolingTask;

    super(
      updateUrl,
      http,
      toolingTaskSettingsDefaults,
      toolingTasksSettingsKey,
      baseUrl,
      'toolingTaskSettings'
    );
  }
}
